import { _apiCall } from '../../../backend/axios'

export function deleteSuperSubRequest(id) {
    return _apiCall(`delete/supersubs/requests/${id}`, 'DELETE')
}
